const View = {
    namespaced: true,
    getters: {},
    state: {
        TabList:[],
        IsShow:false, //客服窗口
    },
    mutations: {
        TABLIST(state, data){
            if(data){
                state.TabList.push(data)
            }else{
                state.TabList = []
            }
        },
        ISSHOW(state, data){
            state.IsShow = data
        }
    },
    actions: {

    },
}
export default View